/* eslint-disable import/prefer-default-export */
export function isIE() {
  return window.navigator.userAgent.indexOf('Trident/') > -1 || window.navigator.userAgent.indexOf('MSIE') > -1
}
